import React from "react";
import { Chip, IconButton } from "@mui/material";
import { createHeaderWithSort } from "./columns";
import refreshIcon from "../../../assets/refresh.svg";
import { getSvgFilter } from "../../dashboard/DashboardUtils";

const getStatusColors = (status) => {
  if (status === "Submitted") {
    return {
      bg: "#F4EFFE",
      text: "#1B2F3F",
      border: "#45B18433",
    };
  } else if (status === "Pending") {
    return {
      bg: "#FEF4E6",
      text: "#1B2F3F",
      border: "#DE820833",
    };
  } else if (status === "Cancelled") {
    return {
      bg: "#FFF3F3",
      text: "#1B2F3F",
      border: "#FEADAC33",
    };
  } else {
    return {
      bg: "#F2F2F5",
      text: "#403C6F",
      border: "#CFCEDA",
    };
  }
};
const getVendorColors = (vendor) => {
  if (vendor) {
    if (vendor === "GRM" || vendor === "ScriptCo" || vendor === "SCRIPTCO") {
      return {
        bg: "#EBF4FF",
        text: "#1B2F3F",
        border: "#45B18433",
      };
    } else {
      return {
        bg: "#F2F2F5",
        text: "#403C6F",
        border: "#CFCEDA",
      };
    }
  }
};

export const getInternationalColumns = (onRefreshClick) => {
  return [
    {
      accessorKey: "id",
      header: createHeaderWithSort("ID", true),
      enableSorting: true,
      size: 120,
      cell: ({ getValue }) => (
        <span style={{ color: "#1B2F3F", fontWeight: 500, fontSize: "15px" }}>
          {getValue()}
        </span>
      ),
    },
    {
      accessorKey: "member",
      header: createHeaderWithSort("Member", true),
      enableSorting: true,
      size: 150,
      cell: ({ getValue }) => (
        <span style={{ color: "#1B2F3F", fontWeight: 500, fontSize: "14px" }}>
          {getValue()}
        </span>
      ),
    },
    {
      accessorKey: "vendor",
      header: createHeaderWithSort("Vendor", true),
      enableSorting: true,
      size: 100,
      cell: ({ getValue }) => {
        const colors = getVendorColors(getValue());
        return (
          <Chip
            label={getValue()}
            size="small"
            sx={{
              fontWeight: 500,
              backgroundColor: colors.bg,
              color: colors.text,
              fontSize: "14px",
              height: "24px",
              px: 2,
              py: 2,
              borderRadius: "12px",
            }}
          />
        );
      },
    },
    {
      accessorKey: "memberId",
      header: createHeaderWithSort("Member ID", true),
      enableSorting: true,
      size: 150,
      cell: ({ getValue }) => (
        <span style={{ color: "#1B2F3F", fontWeight: 500, fontSize: "14px" }}>
          {getValue()}
        </span>
      ),
    },
    {
      accessorKey: "personCode",
      header: createHeaderWithSort("Person Code", true),
      enableSorting: true,
      size: 80,
      cell: ({ getValue }) => (
        <span style={{ color: "#1B2F3F", fontWeight: 500, fontSize: "14px" }}>
          {getValue()}
        </span>
      ),
    },
    {
      accessorKey: "submittedOn",
      header: createHeaderWithSort("Submitted On", true),
      enableSorting: true,
      size: 100,
      cell: ({ getValue }) => (
        <span style={{ color: "#1B2F3F", fontWeight: 500, fontSize: "14px" }}>
          {getValue()}
        </span>
      ),
    },
    {
      accessorKey: "status",
      header: createHeaderWithSort("Status", true),
      enableSorting: true,
      size: 120,
      cell: ({ getValue }) => {
        const colors = getStatusColors(getValue());
        return (
          <Chip
            label={getValue()}
            size="small"
            sx={{
              fontWeight: 500,
              backgroundColor: colors.bg,
              color: colors.text,
              fontSize: "14px",
              height: "24px",
              px: 2,
              py: 2,
              borderRadius: "12px",
            }}
          />
        );
      },
    },
    {
      accessorKey: "patientCareAdvocate",
      header: createHeaderWithSort("Patient Care Advocate", true),
      enableSorting: true,
      size: 120,
      cell: ({ getValue }) => (
        <span style={{ color: "#1B2F3F", fontWeight: 500, fontSize: "14px" }}>
          {getValue()}
        </span>
      ),
    },
    {
      id: "actions",
      header: createHeaderWithSort("Actions", false),
      enableSorting: false,
      size: 80,
      cell: ({ row }) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            width: "100%",
          }}
        >
          <IconButton
            size="small"
            title="View Details"
            sx={{ color: "#403C6F" }}
            onClick={() => onRefreshClick?.(row.original)}
          >
            <img
              src={refreshIcon}
              alt="Refresh"
              style={{ width: 24, height: 24, filter: getSvgFilter("#6E6D92") }}
            />
          </IconButton>
        </div>
      ),
    },
  ];
};
